import { QRCodeMaker } from '@features/portal-tools/sub-features/qr-code-maker/QRCodeMaker'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/qr-code-maker')({
  component: RouteComponent,
})

function RouteComponent() {
  return <QRCodeMaker />
}
